const PROCESSING_VERIFY_CARD = 'processingVerifyCard';

export default PROCESSING_VERIFY_CARD;
